/** @format */
import { Injectable } from '@angular/core';
import { TranslationMarkupRendererFactory } from 'ngx-transloco-markup';
import { HtmlElementTranspiler } from '../common/html-element-transpiler';

export const PARAGRAPH_START = new (class ParagraphStart {})();
export const PARAGRAPH_END = new (class ParagraphEnd {})();

@Injectable()
export class ParagraphTranspiler extends HtmlElementTranspiler {
    constructor(private readonly rendererFactory: TranslationMarkupRendererFactory) {
        super({
            rendererFactory,
            start: {
                search: '<p>',
                token: PARAGRAPH_START,
            },
            end: {
                search: '</p>',
                token: PARAGRAPH_END,
            },
            elementTag: 'p',
        });
    }
}
